module.exports = __webpack_public_path__ + "static/media/logoBcbs.27000bf9.png";